import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { activeNetworkSelector, userSelector } from '../../../../../redux/selectors';
import { useLocalStorage } from '../../../../../hooks/useLocalStorage';

const getStorageKey = (userId, networkId, contactId) => `getro-note-${userId}-${networkId}-${contactId}`;

export const useNoteDraft = ({ contactId }) => {
  const { id: userId } = useSelector(userSelector);
  const { id: networkId } = useSelector(activeNetworkSelector);
  const storageKey = getStorageKey(userId, networkId, contactId);

  const [draft, setDraft] = useLocalStorage(storageKey, null);

  // Save draft to localStorage
  const saveDraft = useCallback(
    (values) => {
      // Only save if there's actual content, otherwise clear the draft
      if (values.title || values.body) {
        setDraft({
          title: values.title,
          body: values.body,
        });
      } else {
        setDraft(null);
      }
    },
    [setDraft],
  );

  // Clear draft from localStorage
  const clearDraft = useCallback(() => {
    setDraft(null);
  }, [setDraft]);

  return {
    draft,
    isLoading: false,
    saveDraft,
    clearDraft,
  };
};
